var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _g6, _path12, _g7, _path13, _path14, _path15, _g8, _path16, _path17, _g9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_871)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 420,
    height: 419
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5833 0H459.417V418.833H40.5833V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_871)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 420,
    height: 419
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 0C134.344 0 40.5833 93.7604 40.5833 209.417C40.5833 325.073 134.344 418.833 250 418.833C365.656 418.833 459.417 325.073 459.417 209.417C459.417 93.7604 365.656 0 250 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5833 0H459.417V418.833H40.5833V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 360,
    width: 290,
    height: 140
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 360.438H394.667V500H105.5V360.438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_871)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 360,
    width: 290,
    height: 140
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250 500L394.5 360.438H105.5L250 500Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.5 360.438H394.438V500H105.5V360.438Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 11,
    width: 400,
    height: 400
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3438 11.651H449.656V410.964H50.3438V11.651Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_871)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 11,
    width: 400,
    height: 400
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250 11.651C139.734 11.651 50.3438 101.042 50.3438 211.307C50.3438 321.573 139.734 410.964 250 410.964C360.266 410.964 449.656 321.573 449.656 211.307C449.656 101.042 360.266 11.651 250 11.651Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3438 11.651H449.656V410.964H50.3438V11.651Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 355,
    width: 276,
    height: 134
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.234 355.292H388V488.349H112.234V355.292Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_871)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 355,
    width: 276,
    height: 134
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250 488.349L387.766 355.292H112.234L250 488.349Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.234 355.292H387.708V488.349H112.234V355.292Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 26,
    width: 372,
    height: 371
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7031 26.0104H435.297V396.604H64.7031V26.0104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_871)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 26,
    width: 372,
    height: 371
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250 26.0104C147.661 26.0104 64.7031 108.969 64.7031 211.307C64.7031 313.646 147.661 396.604 250 396.604C352.339 396.604 435.297 313.646 435.297 211.307C435.297 108.969 352.339 26.0104 250 26.0104Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7031 26.0104H435.297V396.604H64.7031V26.0104Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 307,
    y: 133,
    width: 129,
    height: 152
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M307.109 133.87H435.109V284.87H307.109V133.87Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.984 205.453L493.281 161.755C491.562 159.708 489.047 158.536 486.37 158.536H453.344V142.87C453.344 137.917 449.302 133.891 444.333 133.891H316.104C311.135 133.891 307.089 137.917 307.089 142.87V254.917C307.089 259.865 311.135 263.896 316.104 263.896H334.24C335.557 275.641 345.583 284.807 357.724 284.807C369.859 284.807 379.885 275.641 381.203 263.896H444.333C445.974 263.896 447.51 263.448 448.833 262.682C450.161 263.448 451.693 263.891 453.333 263.891H464.719C466.031 275.641 476.062 284.807 488.203 284.807C500.339 284.807 510.37 275.641 511.687 263.891H523.068C528.042 263.891 532.083 259.865 532.083 254.911V211.214C532.083 209.109 531.333 207.063 529.984 205.453ZM316.104 142.88L444.318 142.87L444.323 167.464C444.323 167.479 444.318 167.5 444.318 167.516V254.901H380.474C377.682 245 368.542 237.719 357.724 237.719C346.901 237.719 337.76 245 334.969 254.906L316.12 254.917L316.104 142.88ZM357.724 275.813C349.667 275.813 343.115 269.286 343.115 261.26C343.115 253.234 349.667 246.708 357.724 246.708C365.776 246.708 372.328 253.234 372.328 261.26C372.328 269.286 365.776 275.813 357.724 275.813ZM488.203 275.813C480.146 275.813 473.594 269.286 473.594 261.26C473.594 253.234 480.146 246.708 488.203 246.708C496.255 246.708 502.807 253.234 502.807 261.26C502.807 269.286 496.255 275.813 488.203 275.813ZM510.953 254.896C508.156 245 499.021 237.719 488.203 237.719C477.38 237.719 468.24 245 465.448 254.901L453.344 254.911V167.531L486.359 167.526L523.057 211.214L523.068 254.896H510.953Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 133,
    width: 135,
    height: 152
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7031 133.87H198.703V284.87H64.7031V133.87Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.74 205.453L160.042 161.755C158.323 159.708 155.802 158.536 153.13 158.536H120.104V142.87C120.104 137.917 116.062 133.891 111.089 133.891H-17.1354C-22.1042 133.891 -26.1511 137.917 -26.1511 142.87V254.917C-26.1511 259.865 -22.1042 263.896 -17.1354 263.896H0.99998C2.31769 275.641 12.3437 284.807 24.4791 284.807C36.6198 284.807 46.6458 275.641 47.9635 263.896H111.089C112.734 263.896 114.266 263.448 115.594 262.682C116.922 263.448 118.453 263.891 120.089 263.891H131.474C132.792 275.641 142.823 284.807 154.958 284.807C167.099 284.807 177.125 275.641 178.443 263.891H189.828C194.797 263.891 198.844 259.865 198.844 254.911V211.214C198.844 209.109 198.094 207.063 196.74 205.453ZM-17.1354 142.88L111.078 142.87L111.083 167.464C111.083 167.479 111.078 167.5 111.078 167.516V254.901H47.2344C44.4427 245 35.3021 237.719 24.4791 237.719C13.6614 237.719 4.52081 245 1.72915 254.906L-17.125 254.917L-17.1354 142.88ZM24.4791 275.813C16.4271 275.813 9.87498 269.286 9.87498 261.26C9.87498 253.234 16.4271 246.708 24.4791 246.708C32.5364 246.708 39.0885 253.234 39.0885 261.26C39.0885 269.286 32.5364 275.813 24.4791 275.813ZM154.958 275.813C146.906 275.813 140.354 269.286 140.354 261.26C140.354 253.234 146.906 246.708 154.958 246.708C163.016 246.708 169.568 253.234 169.568 261.26C169.568 269.286 163.016 275.813 154.958 275.813ZM177.714 254.896C174.917 245 165.781 237.719 154.958 237.719C144.141 237.719 135 245 132.208 254.901L120.104 254.911V167.531L153.12 167.526L189.812 211.214L189.828 254.896H177.714Z",
    fill: "black"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.365 177.448C151.51 176.427 150.245 175.833 148.906 175.833H129.089C126.604 175.833 124.589 177.844 124.589 180.318V202.729C124.589 205.203 126.604 207.208 129.089 207.208H167.651C171.469 207.208 173.552 202.776 171.109 199.859L152.365 177.448Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 234,
    y: 106,
    width: 38,
    height: 105
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M234.484 106.552H271.13V210.115H234.484V106.552Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_871)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 234,
    y: 106,
    width: 38,
    height: 104
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M260.25 203.516L270.859 127.292C271.589 122.073 270.016 116.792 266.557 112.813C263.094 108.833 258.078 106.552 252.807 106.552C247.531 106.552 242.521 108.833 239.057 112.813C235.594 116.792 234.026 122.073 234.75 127.292L245.359 203.516C245.88 207.229 249.057 209.995 252.807 209.995C256.557 209.995 259.734 207.229 260.25 203.516Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.865 106.552H273.75V257.073H231.865V106.552Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 239,
    y: 222,
    width: 28,
    height: 28
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M239.073 222.531H266.542V250H239.073V222.531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_871)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_871",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 239,
    y: 222,
    width: 28,
    height: 28
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M252.807 222.531C245.219 222.531 239.073 228.682 239.073 236.266C239.073 243.849 245.219 250 252.807 250C260.391 250 266.542 243.849 266.542 236.266C266.542 228.682 260.391 222.531 252.807 222.531Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.073 222.531H266.542V250H239.073V222.531Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt);
export default __webpack_public_path__ + "static/media/ct.95f21660c79dc0ff687722adc83adf16.svg";
export { ForwardRef as ReactComponent };